import React from "react"
import DfbQuote from "../ui-kit/dfb_quote"
import DfbImage from "../ui-kit/dfb_image"
import { Transformation } from "cloudinary-react"
import DfbButton from "../ui-kit/dfb_button"
import Section from "./section"

const MImageQuoteCarousel = (props) => {
  const hasDarkBg = props.data.background_color !== "white"

  return (
    <Section
      baseClass={`m-ImageQuoteCarousel ${
        hasDarkBg ? "m-ImageQuoteCarousel--dark" : ""
      }`}
      data={props.data}
    >
      <div className="m-ImageQuoteCarousel-wrapper">
        <div className="m-ImageQuoteCarousel-container">
          <div className="m-ImageQuoteCarousel-carousel">
            <div
              className="dfb-Slider m-ImageQuoteCarousel-slider"
              data-transition="slide"
              data-dark={hasDarkBg ? undefined : true}
              data-indicators
              data-drag
              data-controls
              role="region"
              tabIndex="0"
            >
              <div className="dfb-Slider-slider">
                <ul className="dfb-Slider-slides">
                  {props.data.image_quote.map((item, index) => (
                    <li className="dfb-Slider-slideItem" key={index}>
                      <div className="m-ImageQuoteCarousel-item">
                        {item.image && item.image.src && (
                          <div className="m-ImageQuoteCarousel-image">
                            <DfbImage image={item.image} cover>
                              <Transformation
                                crop="fill"
                                gravity="faces:center"
                                width="1246"
                                height="700"
                                quality="auto"
                                fetchFormat="auto"
                              />
                            </DfbImage>
                            <div className="m-ImageQuoteCarousel-playground" />
                          </div>
                        )}
                        <div className="m-ImageQuoteCarousel-quote">
                          <DfbQuote
                            add_class="dfb-Quote--left"
                            text={item.quote}
                            quote_author={item.quote_author}
                            quote_author_position={item.quote_author_position}
                          />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <ul className="dfb-Slider-controls">
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Left"
                    add_class={`dfb-Slider-control dfb-Slider-control--previous ${
                      hasDarkBg ? "u-Theme-dark" : ""
                    }`}
                    title="previous"
                    filled
                    big
                  />
                </li>
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Right"
                    add_class={`dfb-Slider-control dfb-Slider-control--next ${
                      hasDarkBg ? "u-Theme-dark" : ""
                    }`}
                    title="next"
                    filled
                    big
                  />
                </li>
              </ul>
              <div
                className={`dfb-Indicators dfb-Indicators--secondary dfb-Slider-navContainer ${
                  hasDarkBg ? "u-Theme-dark" : ""
                }`}
              >
                {props.data.image_quote.map((item, index) => (
                  <button
                    className={`dfb-Indicators-item ${
                      index === 0 ? "is-active" : ""
                    }`}
                    data-indicatoritem={index}
                    key={index}
                  >
                    <span className="dfb-Indicators-itemInner" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MImageQuoteCarousel
